import { SignUpError as SignUpErrorCode } from "generatedQueries/signUpMutation.graphql";
import React, { FC } from "react";
import { MessageDescriptor } from "react-intl";
import { WarningMessage } from "shared/components/WarningMessage";
import { mapMessages } from "shared/mapMessages";
import { messages as passwordStrengthMessages } from "shared/validations/validations";
import { sharedMessages } from "shared/sharedMessages";

const messages = mapMessages("components.user.signuperror", {
    validationError: "One or more fields are invalid, please check and try again.",
    codeDeliveryError: "We were unable to deliver the validation code, please check the email address provided or try again later.",
});

interface IProps {
    failureReason: SignUpErrorCode | null;
    passwordStrengthError: MessageDescriptor | string | undefined;
}

export const SignUpError: FC<IProps> = ({
    failureReason,
    passwordStrengthError,
}) => {
    let message: MessageDescriptor | string;

    switch (failureReason) {
        case "VALIDATIONERROR":
            message = messages.validationError;
            break;
        case "CODEDELIVERYFAILURE":
            message = messages.codeDeliveryError;
            break;
        case "INVALIDPASSWORD":
            message = passwordStrengthError ?? passwordStrengthMessages.defaultPasswordStrengthError;
            break;
        default:
            message = sharedMessages.requestFailedBody;
            break;
    }

    return <WarningMessage message={message} />;
};
